import {Card, Modal, Row, Tag} from "antd";
import { styled } from "styled-components";

 const StyledPopUp = styled(Modal)`
  width: 100% !important;
  max-width: 100% !important;


  .ant-modal-content {
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .ant-modal-title {
    font-size: 1rem;
    margin-top: 5px;
  }

  .ant-modal-close-x {
    font-size: 23px;
  }

  .ant-modal-close {
    width: 52px;
    height: 52px;
    border-radius: 400px;
  }

`;
export default StyledPopUp